import { useEffect } from 'react'
import { ThemeProvider, ToastContainer } from '@grofers/dock-design-kit'
import '@grofers/dock-design-kit/dist/index.css'
import './App.css'
import './scripts/InitSentry'
import AppRouter from './routes/AppRouter'
import { setJumboHeaders } from './utils/jumboClient'

function App() {
  useEffect(() => {
    setJumboHeaders()
  }, [])

  return (
    <ThemeProvider defaultTheme="light">
      <AppRouter />
      <ToastContainer />
    </ThemeProvider>
  )
}

export default App
